import { Alert, Typography } from '@mui/material';
import React from 'react';
import { EditorLoaderSettings } from '../../EditorLoaderSettings';

export default () => (
	<>
		<Alert
			severity="info"
			sx={{
				alignItems: 'center'
			}}
			icon={false}
		>
			<Typography variant="body2">
				{intl.tr('screenEditor.settings.pollingLoader.alert')}
			</Typography>
		</Alert>
		<EditorLoaderSettings />
	</>
);
